import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthHeader from './components/Header/AuthHeader';
import AuthFooter from './components/Footer/AuthFooter';

interface AuthLayoutProps {
  header?: React.ReactNode | 'default' | 'none';
  footer?: React.ReactNode | 'default' | 'none';
  bodyClassName?: string;
}

/**
 * Layout component for authentication pages (Login, Activate, Reset Password)
 * Structure: Header (80px) + Body (flex) + Footer (80px). No page scroll; body fills remaining height.
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({
  header = 'default',
  footer = 'default',
  bodyClassName = '',
}) => {
  return (
    <div className="safe-area-top safe-area-bottom h-screen flex flex-col overflow-hidden">
      {/* Header - fixed 80px */}
      {header === 'none' ? null : header === 'default' ? (
        <div className="flex-shrink-0 h-[80px] min-h-[80px] overflow-hidden">
          <AuthHeader />
        </div>
      ) : (
        header
      )}

      {/* Body - fills remaining height */}
      <main className={`flex-1 min-h-0 min-w-0 overflow-hidden ${bodyClassName}`}>
        <Outlet />
      </main>

      {/* Footer - fixed 80px */}
      {footer === 'none' ? null : footer === 'default' ? (
        <div className="flex-shrink-0 h-[80px] min-h-[80px] overflow-hidden">
          <AuthFooter />
        </div>
      ) : (
        footer
      )}
    </div>
  );
};

export default AuthLayout;
